import "./FiltersWrapper.scss";

import React from "react";

import PropTypes from "prop-types";

const FiltersWrapper = ({ children, style }) => {
  return (
    <div className="filters-wrapper" style={style}>
      {children}
    </div>
  );
};

FiltersWrapper.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape(),
};

export default FiltersWrapper;
